import React, { type FC, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";
import { KassenbuchDropdown } from "../KBDropdown";
import { useLocation, useParams } from "react-router-dom";
import { AppRoutes, getRoute } from "@domain/routing/routeConstants";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleKBLinks: FC<{ onOpenSettings: (pk: GQL.IProductKey) => void }> = ({ onOpenSettings }) => {
    const { pathname = "" } = useLocation();
    const { uuid } = useParams<"uuid">();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: "selector",
                label: <KassenbuchDropdown selectedRecordGroup={uuid} />,
            },
            {
                key: AppRoutes.kassenbuchTemplates,
                to: getRoute(AppRoutes.kassenbuchTemplates, { uuid }),
                label: <FormattedMessage id="app.titles.templates" />,
            },
            {
                key: "settings",
                onClick: () => onOpenSettings(GQL.IProductKey.Kb),
                label: <FormattedMessage id="app.titles.settings" />,
            },
        ],
        [uuid, onOpenSettings],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
